import React, { FC } from 'react';
import PropTypes from 'prop-types';
import { Button, Input } from 'esa-ui-library';
import { Form, passFairValidator, passStrongValidator, PasswordIndicator } from '../../../..';
import { REPEAT_INVALID_MESSAGE } from '../../../..';
import { useStore, useValidator } from '../../../../../common';

interface ResetFormProps {
	onSubmit: () => void;
}

const ResetForm: FC<ResetFormProps> = ({ onSubmit }): JSX.Element => {
	const [state, dispatch] = useStore(true);
	const {
		password: initialPassword,
		passwordFair,
		passwordStrong,
		repeatPassword: initialRepeatPassword,
		repeatInvalid,
		errors,
		success,
	} = state;

	const [password, setPassword] = React.useState(initialPassword);
	const [repeatPassword, setRepeatPassword] = React.useState(initialRepeatPassword);

	useValidator(repeatPassword, () => repeatPassword === password, 'REPEAT_INVALID');
	useValidator(password, passFairValidator, 'PASS_FAIR');
	useValidator(password, passStrongValidator, 'PASS_STRONG');

	const onPasswordChange = (val: string) => {
		setPassword(val);
		dispatch('PASS', val);
	};

	const onRepeatChange = (val: string) => {
		setRepeatPassword(val);
		dispatch('REPEAT_PASS', val);
	};

	return (
		<Form errors={errors} success={success}>
			<Input
				type='password'
				label='New Password'
				value={password}
				placeholder='Enter your password here'
				dataId='password-field'
				onChange={onPasswordChange}
			/>
			<Input
				type='password'
				label='Repeat Password'
				value={repeatPassword}
				placeholder='Enter your password here'
				dataId='repeat-pass-field'
				disabled={!password}
				onChange={onRepeatChange}
				error={repeatInvalid}
				errorMessage={REPEAT_INVALID_MESSAGE}
			/>
			{password && <PasswordIndicator fair={passwordFair} strong={passwordStrong} />}
			<Button
				title='Continue'
				fluid
				primary
				disabled={!repeatPassword || repeatInvalid}
				dataId='reset-button'
				onClick={onSubmit}
			/>
		</Form>
	);
};

ResetForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
};

export { ResetForm };
